<template>
<v-container fill-height fluid>
  <v-row>
    <v-col
      align="center"
      justify="center">
        <v-img
          width="160px"
          src="https://pjili-public.s3.ca-central-1.amazonaws.com/global/images/pjili-logo-sm.png"
        ></v-img>
    </v-col>
  </v-row>
  <v-row
    align="center"
    justify="center">
    <v-col>

      <h1 class="text-center mb-5">Welcome to Pjili!</h1>

      <v-card
        class="mx-auto"
        max-width="400"
        outlined>

        <v-alert
          v-if="hasErrors()"
          color="warning">
          <ul>
            <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
          </ul>
        </v-alert>

        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="headline text-center mb-1">Sign in</v-list-item-title>
            <v-list-item-subtitle class="text-center mb-1">Use your Pjili account</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-card-text>
          <v-form @keyup.native.enter="login()">
            <v-text-field
              v-model="Payload.Email"
              name="Email"
              label="Email"
              prepend-icon="mdi-account-circle" />
            <v-text-field
              v-model="Payload.Password"
              :type="showPassword ? 'text' : 'password'"
              name="Password"
              label="Password"
              prepend-icon="mdi-lock"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" 
              @click:append="showPassword = !showPassword"
            />
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-btn
            to="/signup-start"
            rounded
            outlined
            color="grey"
            dark>
            Create account instead
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            @click.prevent="login()"
            rounded
            color="info">
            Sign in
          </v-btn>
        </v-card-actions>

        <v-card-actions>
          <v-btn
            to="/account-recovery"
            text
            class="text-lowercase"
            color="gray"
          >
            Forgot password?
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "Login",
  data() {
    return {
      Payload: {
        Email: '',
        Password: ''
      },
      showPassword: false,
      errors: []
    }
  },
  computed: mapState(["continueHref"]),
  methods: {
    login() {
      this.$axios.post('login', this.Payload)
        .then(() => {
          this.errors = []
          return this.$axios.get('users')
        })
        .then((response) => {
          this.$store.dispatch("SetUser", response.data)
          if (this.continueHref) {
            window.location.href = this.continueHref
          } else {
            this.$router.push({ name: 'account' })
          }
        })
        .catch((error) => {
          if (!error.response) {
            this.errors = ['Network Error']
          }
          this.errors = error.response.data.errors
        })
    },
    hasErrors() {
      return this.errors.length > 0
    }
  }
}
</script>